import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { CaseLockHttpService } from './case-lock-http.service';
import { QueueService } from './queue.service';
import { SettingsService } from './settings.service';
import { PlannedTravel } from './../../shared/models/planned-travel';
import { GlobalErrorHandler } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class UpdatePlannedTravelQueueService extends BaseService {

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService,
    private caseLockHttpService: CaseLockHttpService,
    private queueService: QueueService,
    private globalErrorHandler: GlobalErrorHandler
  ) {
    super(settingsService);
  }

  actionSchedule() {
    if (!this.queueService.anyPlannedTravelQueuedOperationsRunning()) {
      return this.runActions();
    }
  }

  runActions() {
    this.queueService.plannedTravelQueuedOperationsRunning(true);

    const nextPlannedTravel = this.queueService.popPlannedTravel();
    if (nextPlannedTravel == null) {
      return this.queueService.plannedTravelQueuedOperationsRunning(false);
    }

    return this.caseLockHttpService
      .put<PlannedTravel>(this.baseURL + 'travelplans', nextPlannedTravel, { headers: this.jsonHeaders })
      .subscribe(() => {
        this.runActions();
      }, err => {
        this.globalErrorHandler.handleError(err);
        this.runActions();
      });
  }
}
